import { BrandColorsAddStart, BrandColorsDeleteStart, BrandColorsEditStart, BrandColorsLoadStart, getBrandColorsStore } from '@/store/brandcolors/actions';
import { BrandColor } from '@dev/ee-api/ee-api-models';
import { EditorColor } from '@dev/template-editor';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface BrandColorsInTemplateEditor {
    brandColors: EditorColor[];
    onBrandColorAdd: (color: EditorColor) => void
    onBrandColorEdit: (color: EditorColor) => void
    onBrandColorDelete: (color: EditorColor) => void
}

export const useBrandColorsInTemplateEditor = (): BrandColorsInTemplateEditor => {
    const dispatch = useDispatch();
    const { list: brandColorsList, isLoaded: brandColorsListIsLoaded } = useSelector(getBrandColorsStore);
    useEffect(() => {
        if (brandColorsListIsLoaded) {
            return;
        }
        dispatch(BrandColorsLoadStart());
    }, []);
    const brandColors = useMemo(
        () =>
            brandColorsList?.map(
                (brandColor): EditorColor => ({
                    id: brandColor.Hex,
                    name: brandColor.Name,
                    hex: brandColor.Hex,
                })
            ) ?? [],
        [brandColorsList]
    );
    const onBrandColorAdd = (color: EditorColor): void => {
        dispatch(BrandColorsAddStart({ Hex: color.hex, Name: color.name } as BrandColor));
    };
    const onBrandColorEdit = (color: EditorColor): void => {
        const colorIndex = brandColors?.findIndex((brandcolor) => brandcolor.id === color.id);
        dispatch(BrandColorsEditStart(colorIndex, { Hex: color.hex, Name: color.name } as BrandColor));
    };
    const onBrandColorDelete = (color: EditorColor): void => {
        const colorIndex = brandColors?.findIndex((brandcolor) => brandcolor.id === color.id);
        dispatch(BrandColorsDeleteStart(colorIndex, { Hex: color.hex, Name: color.name } as BrandColor));
    };

    return {
        brandColors,
        onBrandColorAdd,
        onBrandColorEdit,
        onBrandColorDelete
    }
};
